function arrowsHandledNativelyByElement(el) {
    return isRadioInput(el);
}
function isRadioInput(el) {
    return isInput(el) && el.type === 'radio';
}
function isInput(el) {
    return el.tagName === 'INPUT';
}

export { arrowsHandledNativelyByElement, isRadioInput };
//# sourceMappingURL=toolbar-primitive.utils.js.map
